module.exports = require("./zh-Hans-HK.d.ts");